import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Randomcode } from "../../components_root/rendom_code";
import { Toast } from '../../components_root/ToastContext';
import { MdArrowBackIos, MdClose, MdDone, MdMoney, MdSave, MdSearch } from "react-icons/md";
import { Save_log_history } from "../../log_history_root/save_log_history";
import Select_yes_no from "../../components_root/select_yes_no";
export default function Update_staff_account({ data }) {
    const [accounts_name, setAccounts_name] = useState("");
    const [description, setDescription] = useState("");
    const [mobile, setMobile] = useState();
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [slug, setSlug] = useState("");
    const [account_type, setAccount_type] = useState("");
    const [accountguid, setaccountguid] = useState("");
    const [queue_verification, setQueue_verification] = useState(false);
     const [administration_login, setAdministration_login] = useState(false);
    const [account_status, setAccount_status] = useState(false);


    const servicetablename = "accountingfinancedb";
    const [verify_note, setVerify_note] = useState("");
    useEffect(() => {
        setaccountguid(data?.accountguid);
        setDescription(data?.description);
        setAccount_type(data?.account_type);
        setAdministration_login(data?.administration_login);
        setQueue_verification(data?.queue_verification);
        setAccount_status(data?.status);
    }, [data]);

    const handleCreate = async () => {
        const logid = Randomcode(25);
        if (!account_type || !account_type.trim()) {
            Toastshow("Please Select role type.");
            return;
        }
        if (!description || !description.trim()) {
            Toastshow("Please enter Description.");
            return;
        }

        if (!verify_note || !verify_note.trim()) {
            Toastshow("Please enter a verification note.");
            return;
        }
        const dataupdates = {
            log_id: logid,
            description: description,
            account_type: account_type,
            administration_login,
            status: account_status,
            // Add other necessary fields here
        };
        create_log(logid, dataupdates, accountguid, "Account", description, verify_note);
    };
    const create_log = async (logid, dataupdates, filedid, account_type, description, verify_note) => {

        const log_description = "account_type:" + account_type + ", " + description;
        const log_data = {
            logid,
            history_type: "Comapany accounts",
            servicetablename: "companies",
            tablename: "staff_accounts",
            filedname: "accountguid",
            filedid: filedid,
            log_description,
            log_status: false,
            verify_status: false,
            verify_note,
            //change info            
            dataupdates,
            description: description,
            account_type: account_type,
        };
        const result = await Save_log_history(log_data);
        if (result.success) {
            //  navigate(-1);
            Toastshow("Saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };

    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    return (
        <div >
            <div className="items-back ">


                <table  >
                    <tr>
                        <td className="button-ui0 text-h2 text-off">Administration login</td>
                        <td width={60}>
                            {account_type === "admin" ? (
                                <Select_yes_no
                                    checked={administration_login}
                                />
                            ) : (
                                <Select_yes_no
                                    checked={administration_login}
                                    onChange={() => setAdministration_login(!administration_login)}
                                />
                            )};
                        </td>
                    </tr>
                     <tr>
                        <td className="button-ui0 text-h2 text-off">Queue verification</td>
                        <td width={60}>
                            {account_type === "admin" ? (
                                <Select_yes_no
                                    checked={queue_verification}
                                />
                            ) : (
                                <Select_yes_no
                                    checked={queue_verification}
                                    onChange={() => setQueue_verification(!queue_verification)}
                                />
                            )};
                        </td>
                    </tr>
                </table> 
                <table> 
                    <tr>
                        <td><div className="text-h2 bold">Account role type</div></td>
                    </tr>

                    <tr>
                        <td>
                            {account_type === "admin" ? (<div className="button-ui fill text-h2 bold red-back p-2">Admin</div>) : (
                                <select
                                    value={account_type}
                                    onChange={(e) => setAccount_type(e.target.value)}
                                    className="text-h2 bold p-2"
                                >
                                    <option value="">Select role type</option>

                                    {/* Administrative */}
                                    <optgroup label="Administrative">
                                        <option value="super_admin">Senior Manager</option>
                                        <option value="manager">Manager</option>
                                        <option value="office_admin">Office Admin</option>
                                        <option value="office_team">Office Team</option>
                                        <option value="hr_manager">HR Manager</option>
                                        <option value="hr_executive">HR Executive</option>
                                    </optgroup>

                                    {/* Operations */}
                                    <optgroup label="Operations">
                                        <option value="staff">Staff</option>
                                        <option value="staff_list">Staff List</option>
                                        <option value="team_leader">Team Leader</option>
                                        <option value="field_staff">Field Staff</option>
                                        <option value="delivery_staff">Delivery Staff</option>
                                        <option value="inventory_manager">Inventory Manager</option>
                                        <option value="store_keeper">Store Keeper</option>
                                        <option value="technician">Technician</option>
                                        <option value="support_staff">Support Staff</option>
                                    </optgroup>

                                    {/* Accounting & Finance */}
                                    <optgroup label="Accounting & Finance">
                                        <option value="accountant">Accountant</option>
                                        <option value="cashier">Cashier</option>
                                        <option value="auditor">Auditor</option>
                                        <option value="finance_manager">Finance Manager</option>
                                        <option value="billing_staff">Billing Staff</option>
                                        <option value="bank">Bank</option>
                                    </optgroup>

                                    {/* Sales & Marketing */}
                                    <optgroup label="Sales & Marketing">
                                        <option value="sales_manager">Sales Manager</option>
                                        <option value="sales_executive">Sales Executive</option>
                                        <option value="marketing_manager">Marketing Manager</option>
                                        <option value="marketing_executive">Marketing Executive</option>
                                        <option value="telecaller">Telecaller</option>
                                        <option value="customer_support">Customer Support</option>
                                    </optgroup>

                                    {/* External Parties */}
                                    <optgroup label="External Parties">
                                        <option value="customer">Customer</option>
                                        <option value="supplier">Supplier</option>
                                        <option value="vendor">Vendor</option>
                                        <option value="contractor">Contractor</option>
                                    </optgroup>

                                </select>

                            )}

                        </td>
                    </tr>
                    <tr>
                        <td><div className="text-h2 bold">Description</div></td>
                    </tr>

                    <tr>
                        <td><textarea className="p-2" value={description} onChange={(e) => setDescription(e.target.value)} maxLength={200} placeholder="Enter description" /></td>
                    </tr>
                    <tr>
                        <td>
                            <input
                                value={verify_note}
                                onChange={(e) => setVerify_note(e.target.value)}
                                maxLength={100}
                                placeholder="Enter a verification note"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="">
                                <table className="table-fixed">
                                    <tr>
                                        <td>
                                            <div
                                                onClick={() => setAccount_status(true)}
                                                className={`fill p-2 cursor ${account_status === true ? "button-ui green-back" : "button-ui2"}`}
                                            >
                                                <MdDone className="icon" />
                                                Activate
                                            </div>
                                        </td>

                                        <td>
                                            <div
                                                onClick={() => setAccount_status(false)}
                                                className={`fill p-2 cursor ${account_status === false ? "button-ui red-back" : "button-ui2"}`}
                                            >
                                                <MdClose className="icon" />
                                                Deactivate
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>
                </table>
                <div className="button-ui p-2 fill text-h2 fcap  cursor" onClick={() => handleCreate()}><MdSave className="icon" />  Update </div>

            </div>
        </div>
    );
}
